import React from "react";
import PoolItemWideLoaderLarge from "./PoolItemWideLoaderLarge";

// Shown above a list of pools: the loader until they arrive (poolVolume -1),
// a notice if there are none, and nothing once there are some.
const PoolListStatus = ({ poolVolume }) => {
  if (poolVolume === -1) return <PoolItemWideLoaderLarge />;
  if (poolVolume === 0) return <div className="panel">No pool currently open.</div>;
  return null;
};

export default PoolListStatus;
